import $ from 'jquery';

// Register CTA AJAX CALL for  no guest 
$(function() {
    $("#cwm-registerCTA_noguest").on("click", function () {
        $('html').css({ 'overflow-y': "hidden" });
        $("#cwm-overlay").show(); 
        var RegisterData = {
            NumberOfAttendees: $("#maxNumberOfGuestAllowed").val(),
            SitecoreEventId: $("#SitecoreEventId").val(),
            }
        $.ajax({ 
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventRegister",
            data:RegisterData,
            dataType: "json",
            success: function (response) {  
                console.log(response.success);
                window.location.reload();    
            },
            error: function (response) {    
                $('html').css({ 'overflow-y': "scroll" });
                $("#cwm-overlay").hide();                      
                console.log(response.error);
            }  
         });
    });

    //Register CTA AJAX CALL for  guest user
	$('#cwm-guest-submit').on( "click", function() {

		// assigning form values and names in to var
		var RegisterData = {
        NumberOfAttendees: $("#cwm-guest-no").val(),
        SitecoreEventId: $("#SitecoreEventId").val(),
		}
			
		$("#cwm-guest-selection-form").validate({			
			submitHandler: function(form) {
                $('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
				$.ajax({
					url: form.action,
					type: form.method,
					data: RegisterData,
					dataType: "json",
					success: function(response) {   
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        $(".cwm-mdl-guest-content").hide();
                        $('.cwm-mdl-guest-selection .modal-confirmation__content').show();                     
                    },                       
                    error: function (response) {   
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();                         
                        console.log(response.success);
                    }             
				});
			}
		});  
	});	 

   // De-Register CTA AJAX call
    $("#cwm-de-RegisterCTA").on("click", function () {
        $('html').css({ 'overflow-y': "hidden" });
        $("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: $("#SitecoreEventId").val(),
            }
        $.ajax({ 
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventDeregister",
            data:EventData,
            dataType: "json",
            success: function (response) { 
                console.log(response.success);
                window.location.reload();    
            },
            error: function (response) {   
                $('html').css({ 'overflow-y': "scroll" });
                $("#cwm-overlay").hide();                       
                console.log(response.error);
            }  
         });
    });

 
  // LeaveWaitingList AJAX call
  $("#cwm-LeaveWaitingList").on("click", function () {    
    $('html').css({ 'overflow-y': "hidden" });
    $("#cwm-overlay").show();
    // assigning form values and names in to var
		var EventData = {
            SitecoreEventId: $("#SitecoreEventId").val(),
            }
    $.ajax({ 
        type: "POST",
        url: "/api/sitecore/CWMEvents/ConnectionEventLeaveWaitingList",
        data: EventData,
        dataType: "json",
        success: function (response) { 
            console.log(response.success);
            window.location.reload();
        },
        error: function (response) {   
            $('html').css({ 'overflow-y': "scroll" });
            $("#cwm-overlay").hide();                       
            console.log(response.error);
        }  
     });
});

// RejoinWaitingList AJAX call
$("#cwm-RejoinWaitingList").on("click", function () {    
    $('html').css({ 'overflow-y': "hidden" });
    $("#cwm-overlay").show();
    var EventData = {
        SitecoreEventId: $("#SitecoreEventId").val(),
        }
    $.ajax({ 
        type: "POST",
        url: "/api/sitecore/CWMEvents/ConnectionEventRejoinWaitingList",
        data: EventData,
        dataType: "json",
        success: function (response) { 
            console.log(response.success);
            window.location.reload();
        },
        error: function (response) {   
            $('html').css({ 'overflow-y': "scroll" });
            $("#cwm-overlay").hide();                       
            console.log(response.error);
        }  
     });
});

// CancelRSVP AJAX call
$("#cwm-CancelRSVP").on("click", function () {       
    $('html').css({ 'overflow-y': "hidden" });
    $("#cwm-overlay").show();
    var EventData = {
        SitecoreEventId: $("#SitecoreEventId").val(),
        }
    $.ajax({ 
        type: "POST",
        url: "/api/sitecore/CWMEvents/ConnectionEventCancelRSVP",
        data:EventData,
        dataType: "json",
        success: function (response) { 
            console.log(response.success);
            window.location.reload();    
        },
        error: function (response) {  
            $('html').css({ 'overflow-y': "scroll" });
            $("#cwm-overlay").hide();                        
            console.log(response.error);
        }  
     });
});

});




 



// WEBPACK FOOTER //
// ./components/cwm-connection-event/cwm-connection-api-integration.js